'use client'

import { useBookingParams } from './useBookingParams'
import { useMemo } from 'react'

export default function useBookingSearchParams() {
  // Includes params that are pushed but not yet committed to the URL
  const { params: searchParams } = useBookingParams()

  // Use useMemo to memoize all parsed values
  return useMemo(() => {
    const fromDateParam = searchParams.get('arrive')
    const toDateParam = searchParams.get('depart')
    const synxisId = searchParams.get('hotel')
    const adult = searchParams.get('adult')
    const child = searchParams.get('child')
    const rooms = searchParams.get('rooms')
    const promo = searchParams.get('promo')
    const rate = searchParams.get('rate')
    const roomConfig = searchParams.get('roomConfig')

    return {
      fromDateParam,
      toDateParam,
      synxisId,
      adult,
      child,
      rooms,
      promo,
      rate,
      roomConfig,
    }
  }, [searchParams]) // Only recalculate when searchParams change
}
